<header-title [model]="headerTitle"></header-title>
<section role="main" class="" *ngIf="headerTitle">
    <div class="row">
        <div class="col">
            <section class="card card-white">
                <header class="card-header">
                    <h3 class="text-gray-600 m-0">{{ headerTitle.title  | htmlToText | truncate:125}}</h3>
                </header>
                <div class="card-body py-5">
                    <form *ngIf="questionDetailsFormGroup" (submit)="updateQuestion()" [formGroup]="questionDetailsFormGroup">
                        <section class="panel">
                            <div class="panel-body">
                                <div *ngIf="!questionDetailsModel.isActive" class="alert alert-warning" role="alert">
                                    This Question is not active.
                                </div>
                                <error-message [errors]="errors"></error-message>

                                <div class="row mt-3">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label class="control-label text-primary">
                                                Title
                                            </label>
                                            <h6 *ngIf="!isEditMode" [innerHtml]="questionDetailsFormGroup.value.title"></h6>
                                            <ckeditor *ngIf="isEditMode" [editor]="Editor" (change)="change($event)" [(ngModel)]="editorData" [ngModelOptions]="{standalone: true}"></ckeditor>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-3">
                                        <label class="control-label text-primary">Response Type</label>
                                        <h6 *ngIf="!isEditMode">{{questionDetailsFormGroup.value.responseType}}</h6>
                                        <select *ngIf="isEditMode" name="responseTypeId" class="form-control" formControlName="responseTypeId">
                                            <option [value]="''">--Select Response Type--</option>
                                            <option *ngFor="let responseType of responseTypes" value="{{responseType.id}}">{{responseType.title}}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-3">
                                        <label class="control-label text-primary">Weighting</label>
                                        <h6 *ngIf="!isEditMode">{{questionDetailsFormGroup.value.weighting}}</h6>
                                        <input *ngIf="isEditMode" type="number" class="form-control" formControlName="weighting" min="1" max="3" />
                                        <div class="text-info">
                                            Default = 1, High = 2, Critical = 3
                                        </div>
                                    </div>

                                    <div class="col-md-3 text-primary">
                                        <label class="control-label">
                                            Is Active
                                        </label>
                                        <input type="checkbox" id="isActive" name="isActive" class="form-control" formControlName="isActive" appToggle [isDisabled]="!isEditMode" />
                                    </div>

                                    <div class="col-md-3 text-end">
                                        <label class="control-label">
                                            &nbsp;
                                        </label>
                                        <button *ngIf="isEditMode" type="button" style="display:block" class="btn btn-danger" (click)="selectedQuestionId=questionDetailsFormGroup.value.id; confirmation.showMessage();">Delete Question</button>
                                    </div>
                                </div>

                                <app-add-question-answer [questionId]="questionDetailsModel.id"
                                                            [isEditMode]="isEditMode"
                                                            (getQuestionAnswers)="onGetQuestionAnswers($event)">
                                </app-add-question-answer>
                            </div>
                            <footer class="panel-footer mt-3">
                                <div class="row">
                                    <div class="col text-end">
                                        <button class="btn btn-outline-primary ms-2" type="button" (click)="onBack()" *ngIf="!isEditMode">Back</button>
                                        <button class="btn btn-primary ms-2" type="button" (click)="toggleEditMode()" *ngIf="(questionDetailsFormGroup.value.isActive) && !isEditMode">Edit</button>
                                        <button class="btn btn-outline-primary ms-2" type="button" (click)="toggleEditMode()" *ngIf="(questionDetailsFormGroup.value.isActive) && isEditMode">Cancel</button>
                                        <button class="btn btn-success ms-2" type="submit" *ngIf="(questionDetailsFormGroup.value.isActive) && isEditMode">Save</button>
                                    </div>
                                </div>
                            </footer>
                        </section>
                    </form>
                </div>
            </section>
        </div>
    </div>

</section>


<app-question-detail-add-question-to-question-bank *ngIf="questionBankId" [isEditMode]="isEditMode"
                                [questionId]="questionId"
                                [questionBankId]="questionBankId"
                                (questionBankQuestionAdded)="onQuestionBankQuestionAdded($event)">
</app-question-detail-add-question-to-question-bank>

<app-alert-message (successClicked)="successClicked($event)"
                   (onHide)="onHide($event)"
                   [title]="'Success'"
                   [message]="'The Question Updated'">
</app-alert-message>

<app-confirmation-message #confirmation (confirmationClicked)="deleteQuestion();"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this question?'">
</app-confirmation-message>


